module.exports = __webpack_public_path__ + "img/L3_open.5f890bde.svg";